import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-line bg-paper" data-id="element-37" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-readable px-6 py-10" data-id="element-38" data-mp="3gfiuujlrgden">
        <p className="text-sm text-muted" data-id="element-39" data-mp="32nukakr5twzs">
          Protocolo CNS — Guía gratuita de verificaciones para iPhone.
        </p>
        <p className="mt-1 text-sm text-muted" data-id="element-40" data-mp="36oy05797jt10">
          © {new Date().getFullYear()} iPhone EXPERTO. No afiliado a Apple Inc.
        </p>
      </div>
    </footer>;
}